import { xcss } from '@atlaskit/primitives';

export const outstandingBalance = xcss({
  borderRightStyle: 'solid',
  borderRightWidth: 'border.width',
  borderRightColor: 'color.border',
});

export const container = xcss({
  borderStyle: 'solid',
  borderWidth: 'border.width',
  borderColor: 'color.border',
  // @ts-ignore
  borderRadius: 8,
});
